import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useLocation, useNavigate as useNavigateReact } from 'react-router-dom';

import { usePathname } from 'src/routes/hooks/use-pathname';
import { useSearchParams } from 'src/routes/hooks/use-search-params';

const useNavigate = () => {
  const navigateReact = useNavigateReact();
  const pathname = usePathname();
  const location = useLocation();
  const searchParams = useSearchParams();

  const verifyParams = (to: string, options?: { replace?: boolean; state?: any }) => {
    if (searchParams.get('token')) {
      if (to.includes('?')) {
        const pathWithParam = `${to}&token=${searchParams.get('token')}`;
        navigateReact(pathWithParam, { ...options, state: { from: pathname } });
      } else {
        const pathWithParam = `${to}?token=${searchParams.get('token')}`;
        navigateReact(pathWithParam, { ...options, state: { from: pathname } });
      }
    } else {
      navigateReact(to, { ...options, state: { from: pathname } });
    }
  };

  const navigate = useCallback(
    (to: string | number, options?: { replace?: boolean; state?: any }) => {
      if (typeof to === 'number') {
        navigateReact(to);
      } else {
        verifyParams(to, options);
      }
    },
    [navigateReact, location.search]
  );

  return navigate;
};

export default useNavigate;
